import { makeAutoObservable, makeObservable, observable } from "mobx";
import Objective from "./Objective";
import ObjectivesLib from "../haxelibs/ObjectivesLib";


export const states = {
  INACTIVE: "INACTIVE",
  ACTIVE: "ACTIVE",
  COMPLETED: "COMPLETED",
  FINISHED: "FINISHED"
}



class ObjectiveFile {

  fileId
  objFile

  /** @type {Array<Objective>} */
  objectives = []

  constructor(fileId, isExternFile = false) {

    this.fileId = fileId
    this.objFile = ObjectivesLib.createFileFromId(fileId, isExternFile)


    this.objectives = this.objFile.objectives.map(o => new Objective(o))

    this.refreshDone = this.refreshDone.bind(this)

    makeObservable(this, {
      objectives: observable
    })


    // makeAutoObservable(this)
  }

  refresh(done = this.refreshDone) {
    this.objFile.refresh((hasChanged, hasProgresschanged) => {
      if (hasChanged) {
        // on refait un refresh si y'a eu un changement d'état, dans le cas où un objectif devient actif suite à la complétion d'un autre objectif
        this.refresh(done)
      }
      else {
        done()
      }


    })
  }
  dirtyRefresh() {
    this.objFile.dirtyRefresh();
    this.refreshObjectivesState();
  }

  refreshObjectivesState() {
    this.objectives.forEach((obj) => obj.refreshState());
  }

  getObjective(id) {
    console.log("getObjective", id)
    return this.objectives.find(obj => obj.id === id)
  }

  get inactiveObjectives() {
    return this.objectives.filter(o => ObjectiveFile.isObjInactive(o))
  }
  get activeObjectives() {
    return this.objectives.filter(o =>  ObjectiveFile.isObjActive(o))
  }
  get completedObjectives() {
    return this.objectives.filter(o => ObjectiveFile.isObjCompleted(o))
  }

  get rootObjectives() {
    return this.objectives.filter(o =>  !o.parent)
  }
  get activeRootObjectives() {
    return this.rootObjectives.filter(o =>  ObjectiveFile.isObjActive(o))

  }
  get completedRootObjectives() {
    return this.rootObjectives.filter(o =>  ObjectiveFile.isObjCompleted(o))
  }


  refreshDone(hasChanged) {
    console.log("Objective file", this.fileId, "done, ", (hasChanged ? " with changes" : "no changes"))
  }

  stateToJson() {
    return  this.objFile.stateToJson()
  }

  stateFromJson(data, forExtern) {
    let context = null
    this.objFile.stateFromJson(context, data, forExtern)

    this.refresh(() => {
      // ne refresh que la partie "react", les states obj de haxe étant set par le stateFromJson
      this.refreshObjectivesState()
    })






  }


  activateUntil(objId) {
    let obj = this.getObjective(objId)
    if(!obj) return

    let index = this.objFile.getObjectiveIndex(objId)

    // récupérer tous les objectifs avant
    this.objectives.forEach((_obj, i) => {
      if(i < index) {
        _obj.sourceObjective.available.force(null, true);
        if(_obj !== obj.parent) _obj.sourceObjective.completed.force(null, true);
      }
    })

    // faire un activate dessus
    obj.sourceObjective.available.force(null, true);

    // refresh
    this.refresh(() => {
      // ne refresh que la partie "react", les states obj de haxe étant set par le stateFromJson
      this.objectives.forEach(obj => {
        obj.refreshState()
      })
    })
  }

  /**
   *
   * @param {Objective} o
   * @returns
   */
  static isObjInactive(o) {
    return o.state === states.INACTIVE
  }
  static isObjActive(o) {
    return o.state === states.ACTIVE
  }
  static isObjCompleted(o) {
    return o.state === states.COMPLETED || o.state === states.FINISHED
  }

}


export default ObjectiveFile